const parseBoolean = (value?: string) => {
  if (value === undefined) {
    return true
  }

  return !['false', '0', 'off'].includes(value.toLowerCase())
}

export const isPodcastEnabled = parseBoolean(process.env.REACT_APP_ENABLE_PODCAST)

export const featureFlags = {
  isPodcastEnabled
}

